import { FeaturedInReviews } from 'Apps/Main/Scenes/Reviews/FeaturedInReviews';
import { IntroReviews } from 'Apps/Main/Scenes/Reviews/IntroReviews';
import { LegalReviews } from 'Apps/Main/Scenes/Reviews/LegalReviews';
import { PressReviews } from 'Apps/Main/Scenes/Reviews/PressReviews';
import { UserReviews } from 'Apps/Main/Scenes/Reviews/UserReviews';

import { MetaData } from 'Components/MetaData';

import ScrollTracker from 'Containers/ScrollTracker';

import { LegacyBaseScene as BaseScene } from 'Scenes/LegacyBaseScene';

const Reviews = () => (
  <>
    <MetaData
      description="After every order, we collect product specific ratings and feedback to increase your satisfaction for always-improving results. See why people love Prose!"
      title="Review & Refine™, Products Reviews and Ratings | Prose"
    />

    <BaseScene footer header>
      <ScrollTracker>
        <IntroReviews />
        <UserReviews />
        <PressReviews />
        <FeaturedInReviews />
        <LegalReviews />
      </ScrollTracker>
    </BaseScene>
  </>
);

export default Reviews;
